import { BaseLoginError } from "./BaseLoginError";

export class UserDesactivated extends BaseLoginError {

    constructor(isShow : boolean) {
        super (isShow);
    }

}